import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
    {
        name: 'Dry Fruit Box',
        path: '/products?category=dry-fruit',
        img: 'https://images.unsplash.com/photo-1536633100220-316886e3f090?auto=format&fit=crop&q=80&w=1000',
        gridSpan: 'lg:col-span-2 lg:row-span-2' // Large featured box
    },
    {
        name: 'Fancy MDF Box',
        path: '/products?category=mdf',
        img: 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&q=80&w=800',
        gridSpan: 'lg:col-span-2 lg:row-span-1' // Wide box matching image ref
    },
    {
        name: 'Sweet Box',
        path: '/products?category=sweet',
        img: 'https://images.unsplash.com/photo-1582231243702-869273c59145?auto=format&fit=crop&q=80&w=800',
        gridSpan: 'lg:col-span-1 lg:row-span-1'
    },
    {
        name: 'Corporate Box',
        path: '/products?category=corporate',
        img: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&q=80&w=800',
        gridSpan: 'lg:col-span-1 lg:row-span-1'
    }
];

const OurCraft = () => {
    return (
        <section className="py-12 md:py-16 bg-brand-cream/30">
            <div className="container-x">

                {/* Header Section - items-end ensures baseline alignment between text and link */}
                <div className="flex flex-row justify-between items-end mb-16 gap-6">
                    <div className="max-w-2xl">
                        <div className="inline-flex flex-col mb-4">
                            <span className="h-[1.5px] w-full bg-brand-gold/80 mb-2"></span>
                            <p className="text-[11px] md:text-sm uppercase tracking-[0.3em] text-brand-gold font-bold leading-none">
                                Our Craft
                            </p>
                        </div>
                        <h2 className="heading-premium text-[38px] md:text-[56px] leading-[1.1]">
                            Eleven categories, <br />
                            <span className="italic text-brand-brown">endless possibilities.</span>
                        </h2>
                    </div>

                    {/* Aligned to the bottom of the heading text */}
                    <div className="pb-2">
                        <Link
                            to="/products"
                            className="group flex items-center gap-3 text-[11px] md:text-[12px] tracking-[0.2em] font-bold text-brand-dark transition-all whitespace-nowrap"
                        >
                            <span className="border-b border-brand-dark group-hover:text-brand-brown group-hover:border-brand-brown pb-1 transition-colors uppercase">
                                VIEW ALL PRODUCTS
                            </span>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="group-hover:translate-x-1 transition-transform">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    </div>
                </div>

                {/* Modern Bento Grid Layout */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 min-h-[700px]">
                    {categories.map((cat, i) => (
                        <Link
                            key={i}
                            to={cat.path}
                            className={`group relative overflow-hidden bg-gray-200 cursor-pointer ${cat.gridSpan}`}
                        >
                            {/* Category Image */}
                            <img
                                src={cat.img}
                                alt={cat.name}
                                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                            />

                            {/* Overlay Gradient */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />

                            {/* Content Over Image */}
                            <div className="absolute inset-0 p-8 flex flex-col justify-end">
                                <span className="text-[10px] tracking-[0.4em] text-brand-gold uppercase font-bold mb-2">
                                    Category
                                </span>
                                <h3 className="text-2xl md:text-3xl font-serif text-white mb-4">
                                    {cat.name}
                                </h3>
                                <div className="flex items-center gap-2 text-white/80 group-hover:text-white transition-colors">
                                    <span className="text-[11px] font-bold tracking-[0.2em] uppercase border-b border-white/30 group-hover:border-white">
                                        Explore
                                    </span>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" className="rotate-[-45deg] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurCraft;